<div class="row">
    <div class="col-12">

        <div class="card">
            <div class="card-header">
                <div class="title">{{ 'PRESET.PRESET_LIST' | translate }}</div>
                <div class="tools">
                     <button type="button" class="btn btn-primary btn-sm" [disabled]="!checkedCheckBox()"
                        (click)="deleteSelected()">
                        <i class="bi bi bi-trash"></i> {{ 'DELETE_SELECTED' | translate }}
                    </button>
                    <button type="button" class="btn btn-primary btn-sm" routerLink="/presets/create">
                        <i class="bi bi-plus-circle"></i> {{ 'ADD' | translate }}
                    </button>
                </div>
            </div>

            <div class="card-body">

                <table class="table table-hover">
                    <thead>
                        <tr>
                            <th scope="col" class="checkbox">
                                <div class="custom-control custom-checkbox">
                                    <input class="custom-control-input" type="checkbox" name="select_preset_all"
                                        id="select_preset_all" [checked]="isAllCheckBoxChecked()"
                                        [indeterminate]="checkedButNotAllCheckBox()"
                                        (change)="checkAllCheckBox($event)">
                                    <label class="custom-control-label" for="select_preset_all"></label>
                                </div>
                            </th>
                            <th scope="col" class="attribute">{{ 'ATTRIBUTE' | translate }}</th>
                            <th scope="col" class="group">{{ 'TYPE' | translate }}</th>
                            <th scope="col" class="organization">{{ 'ORGANIZATION.USER_ORG_ROLES.ORGANIZATION' | translate }}</th>
                            <th scope="col" class="action">{{ 'ACTION' | translate }}</th>
                        </tr>
                    </thead>

                    <tbody *ngIf="presets && presets.length > 0">
                        <tr *ngFor="let preset of presets; let i = index">
                            <td class="checkbox">
                                <div class="custom-control custom-checkbox">
                                    <input class="custom-control-input" type="checkbox" name="select_preset_{{ i }}"
                                        id="select_preset_{{ i }}" [checked]="preset.checked"
                                        (change)="selectedCheckBox(i, $event)">
                                    <label class="custom-control-label" for="select_preset_{{ i }}"></label>
                                </div>
                            </td>
                            <td class="name">{{preset.name}}</td>
                            <td class="group">{{ preset.type}}</td>
                            <td class="organization">{{ preset.owner.name }} {{ preset.owner.ident_num }}</td>
                            <td class="action">
                                <button type="button" class="btn btn-light" routerLink="/presets/edit/{{ preset.id }}"
                                    placement="top" ngbTooltip="{{ 'EDIT' | translate }}">
                                    <i class="bi bi-pencil-square"></i>
                                </button>
                                <button type="button" class="btn btn-light" (click)="onDelete([preset.id])"
                                    placement="top" ngbTooltip="{{ 'DELETE' | translate }}">
                                    <i class="bi bi bi-trash"></i>
                                </button>
                            </td>
                        </tr>
                    </tbody>

                    <tbody *ngIf="!presets || presets.length == 0">
                        <tr>
                            <td *ngIf="loading" class="data-loading" colspan="5">
                                <div class="spinner-bars">
                                    <div class="loadingio-spinner-bars-preLoder-inner">
                                        <div class="preLoder">
                                            <div></div><div></div><div></div><div></div>
                                        </div>
                                    </div>
                                    <div>{{ 'LOADING' | translate }}</div>
                                </div>
                            </td>
                            <td *ngIf="!loading" class="data-not-found" colspan="5">
                                <div>{{ 'DATA_NOT_FOUND' | translate }}</div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="card-footer">
                <app-pagination [pageData]="paginationInput" (pageEvent)="pageEvent($event)"></app-pagination>
            </div>
        </div>
    </div>
</div>